import { render } from "./HelpContent.vue?vue&type=template&id=6c2c3e6c"
import script from "./HelpContent.vue?vue&type=script&lang=js"
export * from "./HelpContent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__